/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXUpIcon24Regular = forwardRef('DataChartBarsXUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M19 3.25a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M14.75 7a.75.75 0 0 0-1.5 0v10a.75.75 0 0 0 1.5 0V7Z" }),
        React.createElement("path", { d: "M4 12.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M1 21a.75.75 0 0 1 .75-.75h20.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 21Z" }),
        React.createElement("path", { d: "M9.75 10a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0v-7Z" })));
});
